export const getNodeProperty = (e6tParam) => {
  const { key, value, ownerType } = e6tParam;
  const fields = [];
  if (key === "owner") {
    fields.push({
      key: "FROM_WHOM",
      value: ownerType.toLowerCase(),
    });
  } else if (key === "build_age") {
    fields.push({
      key: "BUILDING_AGE",
      value: value.map((item) => item.id),
    });
  } else if (key === "room_count") {
    fields.push({
      key: "ROOM_COUNT",
      value: value.map((item) => item.id),
    });
  } else if (key === "floor_number") {
    fields.push({
      key: "APARTMENT_FLOOR",
      value: value.map((item) => item.id),
    });
  } else if (key === "floor_count") {
    fields.push({
      key: "FLOOR_COUNT_OF_BUILDING",
      value: value.map((item) => item.id),
    });
  } else if (key === "heating_type") {
    fields.push({
      key: "HEATING",
      value: value.map((item) => item.id),
    });
  } else if (key === "bath_count") {
    fields.push({
      key: "BATHROOM_COUNT",
      value: value.map((item) => item.id),
    });
  } else if (key === "build_status") {
    fields.push({
      key: "BUILDING_STATUS",
      value: value.map((item) => item.id),
    });
  } else if (key === "star_count") {
    fields.push({
      key: "STAR_COUNT",
      value: value.map((item) => item.id),
    });
  } else if (key === "square" || key === "total_area_square") {
    if (value.min !== null) {
      fields.push({
        key: "MINIMUM_SQUARE_METER",
        value: value.min,
      });
    }
    if (value.max !== null) {
      fields.push({
        key: "MAXIMUM_SQUARE_METER",
        value: value.max,
      });
    }
  } else if (key === "price") {
    if (value.min !== null) {
      fields.push({
        key: "MINIMUM_PRICE",
        value: value.min,
      });
    }
    if (value.max !== null) {
      fields.push({
        key: "MAXIMUM_PRICE",
        value: value.max,
      });
    }
  } else if (key === "square_meter_price") {
    if (value.min !== null) {
      fields.push({
        key: "MINIMUM_SQUARE_METER_PRICE",
        value: value.min,
      });
    }
    if (value.max !== null) {
      fields.push({
        key: "MAXIMUM_SQUARE_METER_PRICE",
        value: value.max,
      });
    }
  } else if (key === "furniture_status") {
    fields.push({
      key: "FURNISHED_OPTION",
      value: value.id,
    });
  } else if (key === "in_site") {
    fields.push({
      key: "IN_APARTMENT_COMPLEX",
      value: value.id,
    });
  } else if (key === "price_trend") {
    fields.push({
      key: "PRICE_TREND",
      value: value.elasticKey,
    });
  } else if (key === "price_index") {
    fields.push({
      key: "PRICE_INDEX",
      value: value.id,
    });
  } else if (key === "suitability_for_credit") {
    fields.push({
      key: "AVAILABLE_FOR_CREDIT",
      value: value.id,
    });
  } else if (key === "suitability_for_investor") {
    fields.push({
      key: "AVAILABLE_FOR_INVESTMENT",
      value: value.id,
    });
  } else if (key === "bed_count") {
    fields.push({
      key: "BED_COUNT",
      value: value.min,
    });
  } else if (key === "settlement_status") {
    fields.push({
      key: "SETTLEMENT_STATUS",
      value: value.id,
    });
  } else if (key === "deed_status") {
    fields.push({
      key: "DEED_POSITION",
      value: value.map((item) => item.id),
    });
  }

  return fields;
};

export const getNodeLocations = (criteria) => {
  const e6tLocations = criteria?.location;
  const region = criteria?.region;
  if (region) {
    return [
      {
        id: region.id,
        name: region.name,
        slug: region.slug,
        type: "region",
        displayedName: region.name,
        displayedAddress: region.name,
        fullName: region.name,
        center: region.center,
        listingCount: null,
        baseWeight: null,
      },
    ];
  }

  if (!e6tLocations) return [];
  const city = e6tLocations.city || {};
  const districts = e6tLocations.districts || [];
  const towns = e6tLocations.towns || [];
  const localities = e6tLocations.localities || [];
  const poies = e6tLocations.poies || [];
  const sites = e6tLocations.sites || [];

  const nodeLocations = [];

  let nodeCity = null;
  let nodeDistricts = [];
  let nodeTowns = [];
  let nodeLocalities = [];
  let nodeSites = [];
  const nodePoies = [];

  if (city) {
    nodeCity = {
      id: city.id,
      name: city.name,
      slug: city.slug,
      type: "city",
      displayedName: city.name,
      displayedAddress: city.name,
      fullName: city.name,
      center: city.center,
      listingCount: null,
      baseWeight: null,
    };

    nodeDistricts =
      districts &&
      districts.map((e6tDistrict) => ({
        id: e6tDistrict.id,
        name: e6tDistrict.name,
        slug: e6tDistrict.slug,
        type: "district",
        displayedName: e6tDistrict.name,
        displayedAddress: city.name,
        fullName: `${e6tDistrict.name}, ${city.name}`,
        center: e6tDistrict.center,
        listingCount: null,
        baseWeight: null,
        related: [city.id],
        city: nodeCity,
      }));

    nodeTowns =
      towns &&
      districts &&
      towns.map((e6tTown) => {
        const parentDistrict = nodeDistricts.filter((district) => district.id === e6tTown.parent.id)[0];
        if (!parentDistrict) return null;

        return {
          id: e6tTown.id,
          name: e6tTown.name,
          slug: e6tTown.slug,
          type: "town",
          displayedName: e6tTown.name,
          displayedAddress: `${parentDistrict.name}, ${city.name}`,
          fullName: `${e6tTown.name}, ${parentDistrict.name}, ${city.name}`,
          center: e6tTown.center,
          listingCount: null,
          baseWeight: null,
          related: [city.id, parentDistrict.id],
          city: nodeCity,
          district: parentDistrict,
        };
      });

    nodeLocalities =
      localities &&
      districts &&
      localities.map((e6tLocality) => {
        const parentDistrict = nodeDistricts.filter((district) => district.id === e6tLocality.parent.id)[0];
        if (!parentDistrict) return null;

        const relatedLocations = e6tLocality.relatedLocations
          ? e6tLocality.relatedLocations.map((relatedLocation) => relatedLocation.id)
          : [];
        relatedLocations.push(city.id);

        return {
          id: e6tLocality.id,
          name: e6tLocality.name,
          slug: e6tLocality.slug,
          type: "locality",
          displayedName: e6tLocality.name,
          displayedAddress: `${parentDistrict.name}, ${city.name}`,
          fullName: `${e6tLocality.name}, ${parentDistrict.name}, ${city.name}`,
          center: e6tLocality.center,
          listingCount: null,
          baseWeight: null,
          related: relatedLocations,
          city: nodeCity,
          district: parentDistrict,
        };
      });

    nodeSites =
      sites &&
      sites.map((e6tSite) => {
        const parentTown =
          nodeTowns && nodeTowns.length && nodeTowns.filter((town) => town.id === e6tSite.parent.id)[0];
        const nodeSite = {
          id: e6tSite.id,
          name: e6tSite.name,
          slug: e6tSite.slug,
          type: "project",
          center: {
            lat: e6tSite.lat,
            lon: e6tSite.lon,
          },
          city: nodeCity,
        };

        if (parentTown) {
          nodeSite.town = parentTown;
        }

        return nodeSite;
      });

    if (districts && poies) {
      poies.forEach((poiCategory) => {
        poiCategory.poies.forEach((e6tPoie) => {
          nodePoies.push({
            id: e6tPoie.id,
            name: e6tPoie.name,
            type: "poi",
            categoryId: poiCategory.categoryId,
            subcategoryId: e6tPoie.poiSubCategoryId,
            center: {
              lat: e6tPoie.lat,
              lon: e6tPoie.lon,
            },
            city: nodeCity,
            district: nodeDistricts && nodeDistricts[0],
          });
        });
      });
    }
  }

  if (nodeSites) {
    nodeSites.forEach((site) => {
      nodeLocations.push(site);
    });
  }

  if (nodePoies) {
    nodePoies.forEach((poi) => {
      nodeLocations.push(poi);
    });
  }

  if (nodeTowns) {
    nodeTowns.forEach((town) => {
      nodeLocations.push(town);
    });
  }

  if (nodeLocalities) {
    nodeLocalities.forEach((locality) => {
      nodeLocations.push(locality);
    });
  }

  if (nodeDistricts && nodePoies && !nodePoies.length) {
    nodeDistricts.forEach((district) => {
      const townsUnderDistrict = nodeTowns && nodeTowns.filter((town) => town.district.id === district.id);
      const locationsUnderDistrict =
        nodeLocalities && nodeLocalities.filter((locality) => locality.district.id === district.id);
      if (
        !(
          (townsUnderDistrict && townsUnderDistrict.length) ||
          (locationsUnderDistrict && locationsUnderDistrict.length)
        )
      ) {
        nodeLocations.push(district);
      }
    });
  }

  if (nodeCity && nodeDistricts && !nodeDistricts.length) {
    nodeLocations.push(nodeCity);
  }
  return nodeLocations;
};

export const getNodeCampaign = (e6tCampaign) => {
  if (!e6tCampaign) return [];
  const nodeCampaigns = [];

  if (e6tCampaign?.key === "campaign") {
    nodeCampaigns.push({
      key: "kampanya",
      value: e6tCampaign?.campaignCacheModel?.queryParamValue,
    });
  }

  return nodeCampaigns;
};

export default {};
